<template>
    <div class="content-container">
        <div class="content">
            <div class="container">
                <div class="row">

                    <!-- Title -->
                    <div class="col-12">
                        <div class="title">
                            <h1>{{ $t('bp.SelectDate.title') }}</h1>
                        </div>
                    </div>

                    <div class="col-12" v-if="loadingAvailability">
                        <loading-state></loading-state>
                        <h4 class="text-center">{{$t('bp.SelectDate.loading')}}</h4>
                    </div>

                    <template v-if="!loadingAvailability">
                        <div class="col-12">
            <!--                <label>Here's the next available date:</label>-->
            <!--                <div class="card-list">-->
            <!--                    <div class="selectable-card active">-->
            <!--                        <div class="card-body justify-content-between">-->
            <!--                            <p>-->
            <!--                                {{ parseDayName(firstDate) }}-->
            <!--                            </p>-->
            <!--                            <p>-->
            <!--                                14:00 - 15:00-->
            <!--                            </p>-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->

            <!--                <label>Other dates:</label>-->
                            <p class="text-muted text-sm">
                                <i class="fa fa-info-circle"></i> {{$t('bp.SelectDate.info')}}
                            </p>

                            <div class="card-list scrollable">
                                <div class="selectable-card"
                                     @click="selectDay(day)"
                                     v-for="(day, timestamp) in filteredAvailabilities"
                                     :key="timestamp"
                                     :class="{ active : dayIsCurrentlySelected(day) }"
                                     :disabled="!day.available">
                                    <div class="card-body justify-content-between">
                                        <p>
                                            {{ parseDayName(day) }}
                                        </p>
                                        <p>
                                          <template v-if="day.available">{{$t('bp.SelectDate.available')}}</template>
                                          <template v-if="!day.available">{{$t('bp.SelectDate.notAvailable')}}</template>
                                        </p>
                                    </div>
                                </div>

                                <template v-if="displayLoadMoreButton">
                                    <button class="btn btn-outline-secondary btn-rounded btn-load-more btn-sm mt-1 mx-auto" @click="loadMoreAvailability()" v-if="!loadingMoreAvailability">
                                        {{$t('bp.SelectDate.loadMore')}}
                                    </button>
                                    <button class="btn btn-outline-secondary btn-rounded btn-load-more btn-sm mt-1 mx-auto disabled" @click="loadMoreAvailability()" v-if="loadingMoreAvailability">
                                        <span><i class="fa fa-spinner fa-pulse"></i></span> {{$t('bp.SelectDate.loadingMore')}}
                                    </button>
                                </template>

                                <router-link v-if="showAlternativeBookingOptions && !showingAtLeastOneAvailableDayWithinDays" :to="{ name: 'repairOptionsExternal'}" class="text-sm text-center">{{$t('bp.SelectDate.alternative')}}</router-link>
                            </div>
                        </div>

                        <!-- Preferred date callback section -->
                        <div class="col-12" v-show="displayPriorityBookingMessage">
                            <div class="alert alert-new alert-info mb-0" >
                                <div class="alert-content">
                                    <div class="form-group mb-2">
                                        <label class="custom-control custom-radio">
                                            <input type="checkbox" class="custom-control-input" v-model="requestPreferredDateCallback" @change="selectDay(null)">
                                            <span class="custom-control-indicator"></span>
                                            <span class="custom-control-description ml-1 font-weight-normal">
                                                {{$t('bp.SelectDate.requestPreferredDate')}}
                                            </span>
                                        </label>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Footer -->
                        <footer class="footer pb-5" :class="footerClass" v-if="!loadingAvailability">
                            <div class="container">
                                <router-link :to="{ name: previousStep}" class="btn btn-outline-secondary back-btn btn-lg"><i class="fa fa-chevron-left text-sm mr-3"></i> {{$t('bp.backButton')}}</router-link>
                                <router-link :to="{ name: nextStep}" class="btn btn-primary btn-lg continue-btn icon-right ml-auto" :class="{'disabled': !booking.date}">{{$t('bp.nextButton')}} <i class="fa fa-chevron-right ml-3 text-sm"></i></router-link>
                            </div>
                        </footer>
                    </template>
                </div>

            </div>
        </div>

        <!-- No dates available modal -->
        <no-dates-available-modal></no-dates-available-modal>
    </div>
</template>

<script>
    import {mapActions, mapGetters} from "vuex";
    import moment from 'moment';

    export default {
        name: "SelectDate",

        mounted() {
            this.checkCanBeOnPage();

            if (!this.showingAtLeastOneAvailableDay) {
                this.initiateLoadAvailability(null, 6);
            }
            if (this.carrierDetails.additionalLandingPage) {
                this.showAlternativeBookingOptions = true;
                if (this.carrierDetails.additionalLandingPageLimit) {
                   this.showAlternativeBookingOptionDayLimit = this.carrierDetails.additionalLandingPageLimit;
                }
            }
        },

        data() {
            return  {
                loadingAvailability: false,
                loadingMoreAvailability: false,
                reloadsCompleted: 0,
                showAlternativeBookingOptions: false,
                showAlternativeBookingOptionDayLimit: 7,
                requestPreferredDateCallback: null,
                selectedDate: null
            }
        },

        computed: {
            ...mapGetters([
                'allowsStoreDropOff',
                'availabilities',
                'booking',
                'carrierDetails',
                'hasAvailability',
                'hasDevices',
                'isBookingInStore',
                'inWarrantyStatus',
                'isApplianceRepair',
                'countryCodeSetting',
                'selectedModel'
            ]),

            displayLoadMoreButton() {
                if (!this.inWarrantyStatus) return true;

                return !this.showingAtLeastOneAvailableDay;
            },

            footerClass() {
                return (window.innerHeight < 768) ? "fixed-footer" : "";
            },

            previousStep() {
                if (this.allowsStoreDropOff && this.isBookingInStore) {
                // if (this.allowsStoreDropOff) {
                    return 'repairOptions';
                }
                return 'basket';
            },

            nextStep() {
                return 'repairLocation';
            },

            filteredAvailabilities() {
                // Get an array of all the timestamps (keys) from your object
                return Object.keys(this.availabilities)
                    .map(timestamp => {
                        // Create a new object for each day, including the timestamp
                        // which we'll need for sorting and for the :key
                        return {
                            timestamp: timestamp,
                            ...this.availabilities[timestamp]
                        };
                    })
                    .sort((a, b) => {
                        // Sort the array chronologically using the timestamp
                        // This ensures the order is always correct
                        return a.timestamp - b.timestamp;
                    });
            },

            showingAtLeastOneAvailableDay() {
                let weAreShowingAnAvailableDay = false;
                for (let key in this.availabilities) {
                    if (!Object.prototype.hasOwnProperty.call(this.availabilities, key)) continue;

                    if (this.availabilities[key].available) {
                        weAreShowingAnAvailableDay = true;
                    }
                }
                return weAreShowingAnAvailableDay;
            },

            showingAtLeastOneAvailableDayWithinDays() {
                let showingAtLeastOneAvailableDayWithinDays = false;
                // Check when the 3 or 7 dat limit is, from now.
                let endDate = moment().add(this.showAlternativeBookingOptionDayLimit, 'day');
                for (let key in this.availabilities) {
                    if (!Object.prototype.hasOwnProperty.call(this.availabilities, key)) continue;

                    // If there is an availability, and it is equal to or before the end date, we return true.
                    if (this.availabilities[key].available && moment(key, 'YYYY-MM-DD').isSameOrBefore(endDate)) {
                        showingAtLeastOneAvailableDayWithinDays = true;
                    }
                }

                return showingAtLeastOneAvailableDayWithinDays;
            },

            displayPriorityBookingMessage() {
                if (!this.selectedModel.priority_booking) {
                    return false;
                }

                for (let key in this.availabilities) {
                    if (!Object.prototype.hasOwnProperty.call(this.availabilities, key)) continue;

                    if (this.availabilities[key].is_tomorrow && !this.availabilities[key].available) {
                        return true;
                    }
                }

                return false;
            },
        },

        methods: {
            ...mapActions([
                'checkBookingIsComplete',
                'loadAvailability',
                'setDate',
                'displayToastFromResponseObjectOfErrors'
            ]),

            addDaysToDate(datetime, days) {
                datetime.setDate(datetime.getDate() + days);
                return datetime;
            },

            checkCanBeOnPage() {
                this.checkBookingIsComplete().then(() => {
                    if (!this.hasDevices) {
                        this.$router.push({name: 'basket'});
                    }
                });
            },

            dayIsCurrentlySelected(day) {
                if (!this.booking.date) return false;
                return (day.date === this.booking.date);
            },

            initiateLoadAvailability(startDate, days) {
                this.loadingAvailability = true;

                this.loadAvailability({ startDate: startDate, daysToLoad: days })
                    .then(() => {
                        this.loadingAvailability = false;
                    }).catch(() => {
                        this.loadingAvailability = false;
                    });
            },

            loadMoreAvailability() {
                // if (this.inWarrantyStatus) {
                //     this.$bvModal.show('no-dates-available-modal');
                //     return;
                // }

                this.reloadsCompleted++;

                let lastDay = this.availabilities[Object.keys(this.availabilities)[Object.keys(this.availabilities).length - 1]];

                let start = new Date();
                if (lastDay !== undefined) {
                    start = new Date(lastDay.date);
                    start = this.addDaysToDate(start, 1);
                } else {
                    start = this.addDaysToDate(start, 5);
                }

                this.loadingMoreAvailability = true;


              this.loadAvailability({ startDate: start, daysToLoad: 5 })
                    .then(() => {
                        this.loadingMoreAvailability = false;

                        if (!this.showingAtLeastOneAvailableDay && this.reloadsCompleted < 6) {
                            this.loadMoreAvailability();
                        }

                    }).catch(() => {
                        this.loadingMoreAvailability = false;
                    });
            },

            parseDayName(day) {
                if (this.countryCodeSetting === 'DE') {
                    return (day.is_tomorrow) ? 'Morgen' : `${day.week_day_full}, ${day.full_date}`;
                } else {
                    return (day.is_tomorrow) ? 'Tomorrow' : `${day.week_day_full} ${day.full_date}`;
                }
            },

            selectDay(day) {
                if (!day) {
                    for (let key in this.filteredAvailabilities) {
                        if (!Object.prototype.hasOwnProperty.call(this.filteredAvailabilities, key)) continue;

                        if (this.filteredAvailabilities[key].date === this.booking.date) {
                            day = this.filteredAvailabilities[key];
                        }
                    }
                }
                if (!day || !day.available) {
                    return;
                }
                this.setDate({
                    date: day.date,
                    requestPreferredDateCallback: this.requestPreferredDateCallback
                }).catch(errors => this.displayToastFromResponseObjectOfErrors(errors));
            }
        }
    }
</script>

<style scoped>

</style>